/**
 * 业务埋点组件导出
 *
 * 封装常见业务场景的埋点逻辑，提供简洁的 API
 */

export { CollectButton } from "./CollectButton";
export type { CollectButtonProps } from "./CollectButton";

export { MaterialCard } from "./MaterialCard";
export type { MaterialCardProps } from "./MaterialCard";

export { trackSearch } from "./trackSearch";
export type { TrackSearchOptions } from "./trackSearch";
